module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmt",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Acknowledgments#sec1"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Preface#sec2"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Frontmatter02#sec3"
    }
  }, [_c('i', [_vm._v("Museum Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toccht",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#sec5"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Paleoenvironments and Stratigraphy of North Africa")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter03#sec6"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Flora of North Africa")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Fauna of North Africa: Invertebrates")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Fauna of North Africa: Vertebrates (Fish)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Fauna of North Africa: Vertebrates (Tetrapoda)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("North African Ecology")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The March of the Oysters")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Cenomanian Mass Extinction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmt",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Appendix#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Literature_Cited#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Literature Cited")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b6a414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 75
// module chunks = 0